module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/feature01-cb10a9cb5afc6a74ddabcea9cbca34a6.svg";